import { Segmented } from 'antd';
import styled from 'styled-components';
import { colors } from 'theme';

export const StyledSegmented = styled(Segmented)`
    padding: 2px;
    border-radius: 6px;

    user-select: none;

    .ant-segmented-item,
    .ant-segmented-item-selected,
    .ant-segmented-thumb {
        border-radius: 2px;
    }

    .ant-segmented-item {
        border-radius: 6px;
        padding: 0 12px;
    }

    .ant-segmented-item-selected {
        color: var(--brand-6);
    }
`;

export const NewStyledSegmented = styled(Segmented)`
    padding: 2px;
    display: inline-flex;
    align-items: center;
    height: 34px;
    border-radius: 8px;
    color: ${colors.grey9};
    background-color: ${colors.buttonGrey};

    user-select: none;

    .ant-segmented-item,
    .ant-segmented-item-label,
    .ant-segmented-item-selected,
    .ant-segmented-thumb {
        border-radius: 8px;
    }

    .ant-segmented-item {
        border-radius: 8px;
        font-size: 14px;
        height: 28px;
    }

    .ant-segmented-item-selected {
        color: ${colors.brand6};
        font-weight: 600;
        font-size: 14px;
    }
`;
